import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';

/**
 * @package store.app.errors
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class ErrorsModule
 */
@Module({ namespaced: true, name: 'app/errors', store })
export class ErrorsModule extends VuexModule {
  private _items: string[] = [];

  public get list(): string[] {
    return this._items;
  }

  @Mutation
  public set(errors: string[]): void {
    this._items = errors;
  }

  @Mutation
  public add(error: string): void {
    if (this._items.includes(error)) {
      return;
    }
    this._items = this._items.concat(error);
  }

  @Mutation
  public clear(): void {
    this._items = [];
  }

  @Mutation
  public remove(index: number): void {
    this._items = this._items.filter((_, i) => i !== index);
  }
}
